import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { buildHttpHeaders } from '../utils/http.utils';
import { AuthUtil } from '../utils/auth.utils';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly authUtil: AuthUtil) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!request.url.includes('agenda-cdn')) {
      request = buildHttpHeaders(request, this.authUtil);
    }
    return next.handle(request);
  }
}
